import makeActionCreator from 'src/lib/makeActionCreator';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const RESET_MODAL = 'RESET_MODAL';

export const openModal = makeActionCreator(OPEN_MODAL);
export const closeModal = makeActionCreator(CLOSE_MODAL);
export const resetModal = makeActionCreator(RESET_MODAL);
